import { useQuery } from '@tanstack/react-query';
import { BASE_URL } from '../constants';

const BASE_QUERY_KEY = `/public/aiConversation/byAgentTemplate/custom-page-style/Header`;

export const useCustomPageStyleHeaderQuery = ({
	agentTemplateId,
	enabled,
}: {
	agentTemplateId: string;
	enabled?: boolean;
}) => {
	return useQuery({
		queryFn: async () => {
			const response = await fetch(
				`${BASE_URL}/public/aiConversation/byAgentTemplate/custom-page-style/Header?agentTemplateId=${agentTemplateId}`
			);
			if (response.status !== 200) {
				return null;
			}
			const htmlContent = await response.text();
			return htmlContent;
		},
		queryKey: [BASE_QUERY_KEY, agentTemplateId],
		enabled,
	});
};
